import React from 'react';
import styled from 'styled-components';
import vw from 'src/styles/utils';
import ArrowButton from 'components/ArrowButton';

const LegalContact = ({ setLegalContactOpen }) => {
  return (
    <Root>
      <Popup>
        <Title>
          <h1>This Strata Lot has already submitted a Lawyer / Notary.</h1>

          <h2 className="strapline">
            Please contact{' '}
            <a className="lnk" href="mailto:info@theamazingbrentwood.com">
              info@theamazingbrentwood.com
            </a>{' '}
            if you want to change your Lawyer / Notary or have any further
            inquiries.
          </h2>

          <nav>
            <ArrowButton
              text="Close Popup"
              handleClick={() => setLegalContactOpen(false)}
            />
          </nav>
        </Title>
      </Popup>
    </Root>
  );
};

export default LegalContact;

const Root = styled.main`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  font-family: Big Caslon;
  nav {
    ${vw('margin-top', 25, 30)}
  }

  h1 {
    ${vw('margin-bottom', 50)}
  }
  h2 {
    ${vw('padding-bottom', 10, 75, 20)}
  }
  .lnk {
    color: #000;
  }
`;

const Title = styled.div``;

const Popup = styled.div`
  position: absolute;
  ${vw('width', 300, 600, 900)}
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${(props) => props.theme.color.white};
  ${vw('padding-left', 25, 60, 80)}
  ${vw('padding-right', 25, 60, 80)}
  ${vw('padding-bottom', 50, 75, 80)}
  ${vw('padding-top', 50, 75, 80)}
`;
